export const getRemainingDays = (returnDate) => {
  const presentTime = new Date().getTime();
  const timeBetweenDates = new Date(returnDate).getTime() - presentTime;
  const daysRemaining = Math.round(timeBetweenDates / (1000 * 60 * 60 * 24));
  return daysRemaining;
};
